// extracted by mini-css-extract-plugin
module.exports = {"navigation":"MainNavigation_navigation__ut8bk","navigationItem":"MainNavigation_navigationItem__3hLOz","navigationItemActive":"MainNavigation_navigationItemActive__3u93E"};